/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Reducer for proConData
 */

import { ProConData } from '@zcode/nr/es/shared/bizos/pro_con_data'
import { payloadReducer } from '@zcode/reducers'
import type { ProConDataModule } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { RECEIVE_PRO_CON_DATA } from '../constants/index'
import { metaReducer } from './meta'
import type { ActionTypes } from './types'

export const proConDataReducer = combineReducers<ProConDataModule, ActionTypes>({
  data: handleActions<ProConDataModule['data'], ActionTypes>(
    {
      [RECEIVE_PRO_CON_DATA]: payloadReducer,
    },
    new ProConData({})
  ),
  meta: metaReducer,
})
